import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../lightningserver/LsErrorException.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  ExceptionMessage21t2b5aa8xtox as ExceptionMessage,
  ExceptionToMessage30hyfnqwmqxl4 as ExceptionToMessage,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function installLsError(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.exceptions.ExceptionToMessage' call
  var tmp$ret$0 = new (installLsError$$inlined$ExceptionToMessage$1())(0.6);
  _this__u8e3s4.plusAssign_2usnwd_k$(tmp$ret$0);
}
var installLsError$$inlined$ExceptionToMessage$1Class;
function installLsError$$inlined$ExceptionToMessage$1() {
  if (installLsError$$inlined$ExceptionToMessage$1Class === VOID) {
    class $ {
      constructor($priority) {
        this.priority_1 = $priority;
        this.forSpecificException_1 = true;
      }
      get_priority_jyafsd_k$() {
        return this.priority_1;
      }
      get_forSpecificException_cnbvel_k$() {
        return this.forSpecificException_1;
      }
      message_rracq9_k$(context, exception, metadata) {
        if (!(exception instanceof LsErrorException()))
          return null;
        report(exception);
        // Inline function 'kotlin.takeUnless' call
        var this_0 = exception.error_1.message_1;
        var tmp;
        if (!isBlank(this_0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_elvis_lhs = tmp;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          switch (exception.get_status_jnf6d7_k$()) {
            case 400:
              tmp_0 = 'Incorrectly formed information was sent.';
              break;
            case 401:
              tmp_0 = "You're not authenticated properly.";
              break;
            case 403:
              tmp_0 = "You're not allowed to do this.";
              break;
            case 500:
              tmp_0 = "Something's wrong with the server.";
              break;
            default:
              tmp_0 = 'Got a code ' + exception.get_status_jnf6d7_k$() + ' from the server.';
              break;
          }
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        return new (ExceptionMessage())('Error', tmp_0);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ExceptionToMessage()]);
    installLsError$$inlined$ExceptionToMessage$1Class = $;
  }
  return installLsError$$inlined$ExceptionToMessage$1Class;
}
//region block: exports
export {
  installLsError as installLsError111711da0k22u,
};
//endregion

//# sourceMappingURL=LsErrorHandlers.mjs.map
